
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class FiCreditorReaderService {

   public static getFiCreditorInfo(
           axiosInstance: AxiosInstance, input: ServerData.FiCreditorWebReader.GetFiCreditorInfo$Input,
           f: (output: ServerData.SpineData$FiCreditor) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/ficreditor/get-fi-creditor-info',
            {params : input.toJson()}
        ).then((response) => ServerData.SpineData$FiCreditor.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getFiCreditorSifDocumentList(
           axiosInstance: AxiosInstance, input: ServerData.FiCreditorWebReader.GetFiCreditorSifDocumentList$Input,
           f: (output: ServerData.SpineData$FiDocument[]) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/ficreditor/get-fi-creditor-sif-document-list',
            {params : input.toJson()}
        ).then((response) => (response.data as object[]).map((x) => ServerData.SpineData$FiDocument.fromJson(x)))
       .then((output) => f(output))
       .catch(theEh);
   }


}

